import DomainWrapper from "banks/DomainWrapper";
import React from "react";

const App = () => {
  return (
    <>
      <DomainWrapper />
    </>
  );
};

export default App;

{
  /* <Route exact path="/" render={(props) => <Customer {...props} />} />
      <Route exact path="/b2b" render={(props) => <B2B {...props} />} />
      <Route exact path="/Agent" render={(props) => <Agent {...props} />} /> */
}
